import { render } from "./ContactView.vue?vue&type=template&id=364c60eb"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=364c60eb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ContactView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "364c60eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('364c60eb', __exports__)) {
    api.reload('364c60eb', __exports__)
  }
  
  module.hot.accept("./ContactView.vue?vue&type=template&id=364c60eb", () => {
    api.rerender('364c60eb', render)
  })

}


export default __exports__